import React from 'react';
import { Box, Typography } from '@mui/material';
import { FaFacebookF, FaTwitter, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#6c8490',
        color: 'white',
        padding: '20px 0px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        bottom: 0,
        width: '100%',
      }}
    >
      <Typography>
        {/* <div className='footer-contact-header'>
          All welcome to join!
        </div> */}
        <ul className='footer-contact-list'>
          <li>Email: <a
            href="mailto:info@monmouthskiclub.com">info@monmouthskiclub.com</a></li>
          <li>Lodge Address: <a href='https://maps.app.goo.gl/L3BKouEVjoYVDMWB8'>3818 US-7, Pittsford, VT 05763</a></li>
        </ul>
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '15px',
          marginTop: '10px',
        }}
      >
        <a href="https://www.facebook.com/groups/109859425745091" target="_blank" rel="noopener noreferrer" style={{ color: 'white' }}>
          <FaFacebookF size={20} />
        </a>
      </Box>
    </Box>
  );
};

export default Footer;
